"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddItemsToService = exports.AdminImpersonation = exports.IsModernOrderingEnabled = exports.isAccountOwner = exports.UserKey = exports.impersonateInfo = exports.IsWebView = void 0;
exports.IsWebView = 'isWebView';
exports.impersonateInfo = {
    targetUserId: 'targetUserId',
    targetUserKey: 'targetUserKey',
    targetBrandId: 'targetBrandId',
};
exports.UserKey = 'UserKey';
exports.isAccountOwner = 'isAccountOwner';
exports.IsModernOrderingEnabled = 'isModernOrderingEnabled';
exports.AdminImpersonation = {
    BrandIdCookieName: 'impersonatingBrandId',
    AdminCognitoConfigIdentifier: 'default',
    LocalUserPortalUrl: 'http://localhost:3000/',
    LocalOrderingPortalUrl: 'http://localhost:3003',
    QAUserPortalUrl: 'https://user.qa.test.flexischools.com.au/',
    QAOrderingPortalUrl: 'https://ordering.qa.test.flexischools.com.au',
    ProdUserPortalUrl: 'https://user.flexischools.com.au/',
    ProdOrderingPortalUrl: 'https://ordering.flexischools.com.au',
};
exports.AddItemsToService = {
    SupplierServiceKey: 'AddItemsToService_supplierServiceKey',
};
//# sourceMappingURL=Constants.js.map